<template>
    <app-layout title="Add Customer Credit Card">
        <form @submit.prevent="submit">
            <page-header>
                <template #title>Add Customer Credit Card</template>

                <template #actions>
                    <!-- <jet-button v-show="form.isDirty" type="submit" class="h-7 leading-none"> -->
                    <jet-button type="submit" class="h-7 leading-none" :disabled="form.processing" >
                        Save
                    </jet-button>

                    <!-- <jet-tertiary-button class="h-7 leading-none" :disabled="form.processing" :href="route('customers.index')"> -->
                    <jet-tertiary-button class="h-7 leading-none" :href="route('customers.card_vault', customer.id)">
                        {{ form.isDirty ? 'Cancel' : 'Close' }}
                    </jet-tertiary-button>
                </template>
            </page-header>

            <div class="px-8 xl:flex">
                <card-vault-form 
                    :form="form" 
                />
            </div>
        </form>
    </app-layout>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3';
import JetButton from '@/Jetstream/Button';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import CardVaultForm from '@/Pages/Customer/Partials/CardVaultForm.vue';

import '@vueform/multiselect/themes/default.css';
import '@vueform/toggle/themes/default.css';

export default {
    setup() {
        const form = useForm({
            id:             false,
            street_number:  null,
            street_name:    null,
            postal:         null,
            last_four:      null,
            expiry:         null,
            cvd:            null,
            brand:          null,
            city:           null,
            province:       'Ontario',
            first_name:     null,
            last_name:      null,
            phone:          null,
        })

        return { form }
    },

    components: {
        AppLayout,
        PageHeader,
        JetButton,
        JetTertiaryButton,
        CardVaultForm
    },

    props: [
        'customer',
    ],

    methods: {
        submit() {
            this.form.post(route('customers.card_vault.store', this.$page.props.customer.id));
        },
    },
}
</script>

<style scoped>

</style>
